/**
 * Disabilita i metodi console in produzione (tranne console.error)
 * Da importare all'inizio di main.tsx
 */
if (import.meta.env.PROD) {
  const noop = () => {};

  console.log = noop;
  console.warn = noop;
  console.info = noop;
  console.debug = noop;
  console.trace = noop;
  console.dir = noop;
  console.dirxml = noop;
  console.table = noop;
  console.group = noop;
  console.groupCollapsed = noop;
  console.groupEnd = noop;
  console.time = noop;
  console.timeEnd = noop;
  console.timeLog = noop;
  console.count = noop;
  console.countReset = noop;
  console.clear = noop;
  console.profile = noop;
  console.profileEnd = noop;

  // console.error rimane attivo per errori critici

  // Messaggio anti-XSS
  console.error(
    '%c⚠️ ATTENZIONE!',
    'color: red; font-size: 40px; font-weight: bold;'
  );
  console.error(
    '%cSe qualcuno ti ha chiesto di copiare e incollare qualcosa qui, ' +
      'NON FARLO! Potrebbe essere un tentativo di rubare i tuoi dati o ' +
      'compromettere il tuo account.',
    'color: red; font-size: 16px;'
  );
  console.error(
    '%cQuesta funzionalità è riservata agli sviluppatori.',
    'font-size: 14px;'
  );
}
